/**
 * TEMPORARY FIX — Product Row Flickity viewport height
 *
 * Bug: ProductRowScroller (in empire.js) sets height on .flickity-slider
 * via the 'heightUpdate.product-row' event, but never sets height on its
 * parent .flickity-viewport. Since .flickity-viewport's CSS default is
 * height: 100% (and setGallerySize: false disables Flickity's own auto-
 * sizing), .flickity-viewport collapses to 0px on mobile, clipping the
 * fully-built, correctly-sized slider to nothing visible.
 *
 * Fix: listen for the same 'heightUpdate.product-row' event the theme
 * already triggers, and additionally apply that height to .flickity-viewport.
 * This does not replace or fight the theme's own handler — it runs
 * alongside it and fills in the one line it's missing.
 *
 * Remove this file once Archetype/Pixel Union ships a fix in empire.js
 * itself, or once ProductRowScroller is patched directly during a future
 * theme update.
 */
(function () {
  function syncHeight($productRow) {
    var $slider = $productRow.find('.flickity-slider');
    var $viewport = $productRow.find('.flickity-viewport');

    console.log('[flickity-viewport-fix]', {
      sliderFound: $slider.length,
      viewportFound: $viewport.length,
      sliderHeight: $slider.height()
    });

    if (!$slider.length || !$viewport.length) return;

    var height = $slider.height();
    if (height > 0) {
      $viewport.height(height);
    }
  }

  function init($) {
    // Catch future events (resize, cellSelect, etc.)
    $(document).on('heightUpdate.product-row', '[data-product-row]', function () {
      syncHeight($(this));
    });

    // Catch the case where init's one-time trigger already fired
    // before this listener was bound (async script load race).
    $('[data-product-row].flickity-enabled').each(function () {
      syncHeight($(this));
    });
  }

  function waitForJQuery(attempts) {
    if (window.jQuery) {
      init(window.jQuery);
      return;
    }
    if (attempts <= 0) {
      console.warn('[flickity-viewport-fix] jQuery never became available, giving up.');
      return;
    }
    setTimeout(function () {
      waitForJQuery(attempts - 1);
    }, 100);
  }

  waitForJQuery(50);
})();